import { Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
	selector: '[msResponsiveTableColumn]',
	standalone: true
})
export class ResponsiveTableColumnDirective {
	public readonly elementRef = inject(ElementRef<HTMLElement>);

	public readonly msResponsiveTableColumn = input.required<string>();
	public readonly priority = input.required<number>();
}
